export default __webpack_public_path__ + "static/media/IMG_9994.4dc520be.webp";